import React, { Component } from "react";
import Header from './Header';
import Footer from './Footer';

class Home extends Component {
    
    constructor(props)
    {
        super(props);
        this.state = {detail:''};
    }

    componentWillMount()
    {
        
    }
    
  render() {
    return (
        <React.Fragment>
            <Header />

            <main role="main">

                <section className="jumbotron text-center">
                    <div className="container">
                        <h1 className="jumbotron-heading">Album example</h1>
                        <p className="lead text-muted">Something short and leading about the collection below—its contents, the
                            creator, etc. Make it short and sweet, but not too short so folks don’t simply skip over it
                            entirely.</p>
                        <p>
                            <a href="#" className="btn btn-primary my-2">Main call to action</a>
                            <a href="#" className="btn btn-secondary my-2">Secondary action</a>
                        </p>
                    </div>
                </section>
            </main>

            <Footer />
        </React.Fragment>
    );
  }
}

export default Home;